import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-how-it-works.scss'
import LeaderLine from "leader-line-new"

/**
 * How it works module
 * We are using a library called LeaderLine which Draws and Connects SVGs to specific DOM elements
 */
function connectAllLeaderLines() {
    const img1 = document.getElementById(`how-it-works__step-image--1`)
    const img2 = document.getElementById(`how-it-works__step-image--2`)
    const img3 = document.getElementById(`how-it-works__step-image--3`)
    const img4 = document.getElementById(`how-it-works__step-image--4`)

    const options = {
        color: `rgb(37, 214, 201)`,
        startSocket: `bottom`,
        endSocket: `top`,
        startPlug: `behind`,
        endPlug: `arrow1`,
        size: 2,
        dash: {len: 16, gap: 8},
        startPlugSize: 2,
        endPlugSize: 2
    }
    const area = {
        shape: `rect`,
        width: `30%`,
        height: `30%`,
        fillColor: `transparent`,
        size: 0
    }
    const secondImageArea = {
        ...area,
        x: `5%`,
        y: `25%`
    }
    const thirdImageArea = {
        ...area,
        x: `58%`,
        y: `12%`
    }
    const fourthImageArea = {
        ...area,
        x: `5%`,
        y: `8%`
    }

    let line1 = new LeaderLine(img1, LeaderLine.areaAnchor(img2, secondImageArea), options)
    let line2 = new LeaderLine(img2, LeaderLine.areaAnchor(img3, thirdImageArea), options)
    let line3 = new LeaderLine(img3, LeaderLine.areaAnchor(img4, fourthImageArea), options)

    function redrawLines() {
        line1.position(),
        line2.position()
        line3.position()
    }
    window.addEventListener(`load`, redrawLines)
    window.addEventListener(`scroll`, redrawLines)
}

export default register(`section-how-it-works`, {
    onLoad() {
        connectAllLeaderLines()
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})

